import { render } from "./Bottom.vue?vue&type=template&id=3f9d24fb&scoped=true&ts=true"
import script from "./Bottom.vue?vue&type=script&lang=ts"
export * from "./Bottom.vue?vue&type=script&lang=ts"

import "./Bottom.vue?vue&type=style&index=0&id=3f9d24fb&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9d24fb"]])

export default __exports__